export type TSpellInfo = {
  id: number;
  school: number;
  icon: string;
  name: string;
  description?: string;
  rank: null | number;
  hasCooldown?: boolean;
};

export type TGetSpellsParams = {
  search?: string;
  limit: number;
  page: number;

  slugs?: string[];
  ids?: number[];
};

export type TGetSpellsListResponse = {
  data: TSpellInfo[];
};

export enum SpellCategory {
  Bloodlust = 'bloodlust',
  CombatResurrection = 'combat-resurrection',
  Shroud = 'shroud'
  // Defensive = 'defensive',
  // Offensive = 'offensive'
}
